import CustomDrawer from "@/components/drawer";
import {
  ActionIcon,
  Affix,
  Box,
  Button,
  Card,
  Checkbox,
  Stack,
  Text,
  Title,
  Transition,
} from "@mantine/core";
import { IconFilter, IconUsersGroup } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import UserFilterItem from "./UserFilterItem";
import { UserAppointmentsDto } from "@/models/club";
import { useNavigate } from "react-router-dom";

type Props = {
  opened: boolean;
  close: () => void;
  open: () => void;
  data: UserAppointmentsDto[];
  value: string[];
  setValue: (value: string[]) => void;
  // Floating button (mobile); desktop opens the filter from the calendar toolbar.
  withTrigger?: boolean;
};

function UsersFilter({ opened, close, open, data, value, setValue, withTrigger = true }: Props) {
  // Local state for temporary selections before applying filter
  const [tempSelection, setTempSelection] = useState<string[]>(value);
  const navigate = useNavigate();
  // Handle filter button click
  const handleApplyFilter = () => {
    setValue(tempSelection);
    navigate(-1);
  };

  // Start from the applied selection whenever the drawer opens, whichever control opened it
  useEffect(() => {
    if (opened) setTempSelection(value);
  }, [opened]); // eslint-disable-line react-hooks/exhaustive-deps

  // Reset temp selection when drawer opens
  const handleOpen = () => {
    setTempSelection(value);
    open();
  };

  return (
    <>
      {withTrigger && <Affix position={{ bottom: 80, right: 20 }} zIndex={4}>
        <Transition mounted={true} transition="slide-up">
          {(transitionStyles) => (
            <ActionIcon
              variant="default"
              onClick={handleOpen}
              style={transitionStyles}
              w={50}
              h={50}
              radius="xl"
              styles={{
                root: {
                  border: "none",
                  boxShadow: "0 8px 32px 0 #14141429",
                },
              }}
            >
              <IconUsersGroup stroke={1.5} />
            </ActionIcon>
          )}
        </Transition>
      </Affix>}
      <CustomDrawer
        opened={opened}
        onClose={close}
        close={close}
        title=""
        radius="md"
        position="bottom"
        size="lg"
        custom="select-customer"
        styles={{
          body: {
            padding: 0,
          },
        }}
      >
        <Box
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            minHeight: "84svh",
          }}
        >
          <Box
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
            }}
            px="md"
          >
            <Title order={5}>تیم</Title>
            <Text c="dimmed" size="xs">
              افرادی از تیم را که می‌خواهید نمایش داده شوند انتخاب کنید
            </Text>

            <Checkbox.Group value={tempSelection} onChange={setTempSelection}>
              <Stack pt="md" gap="lg">
                {data?.map((item) => (
                  <UserFilterItem key={item.user?.id} user={item.user!} />
                ))}
              </Stack>
            </Checkbox.Group>
          </Box>

          <Card
            styles={{
              root: {
                position: "sticky",
                bottom: 0,
                zIndex: 10,
              },
            }}
            withBorder
            radius={0}
          >
            <Button
              size="md"
              fullWidth

              onClick={handleApplyFilter}
              leftSection={<IconFilter size={16} />}
            >
              اعمال
            </Button>
          </Card>
        </Box>
      </CustomDrawer>
    </>
  );
}

export default UsersFilter;
